<template>
  <div class="home-page">
    <home-page-hero />
    <home-page-cta />
  </div>
</template>

<script>
import PageMixin from '../../shared/pageMixin';
import HomePageCTA from '../../components/webv2/homeexp/HomePageCTA';
import HomePageHero from '../../components/webv2/homeexp/HomePageHero';

export default {
  name: 'Home',
  components: {
    'home-page-cta': HomePageCTA,
    'home-page-hero': HomePageHero,
  },
  mixins: [PageMixin],
  mounted() {
    this.setMetaInformation('Luminary | Listen to Luminary Original Podcasts', 'Luminary is a subscription podcast network with an award-winning collection of original shows you won\'t find anywhere else. Start your 7-day free trial today!');
  },
  destroyed() {
    this.setMetaInformation();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.home-page {
  background-color: $bg-color;
}
</style>
